import Velocity from 'velocity-animate'
export default {
  methods: {
    enter(el, done) {
      Velocity(
        el,
        'slideDown',
        { duration: 150, easing: 'easeInBack' },
        { complete: done }
      )
    },
    leave(el, done) {
      Velocity(
        el,
        'slideUp',
        { duration: 150, easing: 'easeInBack' },
        { complete: done }
      )
    }
  }
}
